














































































import { Mixins, Component } from 'vue-mixin-decorator';
import CardOverlay from '@/components/CardOverlay.vue';
import BannerGrid from '@/components/BannerGrid.vue';
import LuanchGameMixin from '@/mixins/luanchGameMixin';
import AuthConnector from '@/connector/Auth.vue';
import DialogConnector from '@/connector/Dialog.vue';

@Component({
  components: {
    CardOverlay,
    BannerGrid,
    AuthConnector,
    DialogConnector,
  },
})
export default class CasualPage extends Mixins<LuanchGameMixin>(LuanchGameMixin) {}
